<template>
  <OrderDocumentList 
    :order="order"    
    @documentsCreated="onEventDocumentsCreated"
  />
</template>

<script>
  import OrderDocumentList from './OrderDocumentList.vue';

  export default {
    name: 'OrderDetailTabsDocuments',
  
    components: {
      OrderDocumentList
    },

    props: {
      order: {
        type: Object,
        required: true
      }
    },

    methods: {
      onEventDocumentsCreated() {        
        this.$emit('event');
      }
    }
  };
</script>